// extracted by mini-css-extract-plugin
export default {"page":"OrdersPage_page__46rJT","overlay":"OrdersPage_overlay__b+T6w","drawer":"OrdersPage_drawer__u7gFG","head":"OrdersPage_head__vaA-R","close":"OrdersPage_close__53ore"};